import React, { useState, useEffect, useRef } from "react";
import "./Header.css";

const Header = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const headerRef = useRef(null);

  const IMAGES = [
    "./header-banner13.webp",
    "./header-banner11.webp",
    "./header-banner14.webp",
  ];

  // Auto slide transition
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % IMAGES.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [IMAGES.length]);

  // Manual slide controls
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <header className="header" ref={headerRef}>
      {/* Parallax background slides */}
      <div className="header__slides">
        {IMAGES.map((src, index) => (
          <div
            key={index}
            className={`header__slide ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${src})` }}
            aria-hidden={index !== currentSlide}
          />
        ))}
      </div>

      {/* Black overlay */}
      <div className="header__overlay" aria-hidden="true" />

      {/* Content */}
      <div className="header__content">
        <div className="header__content-inner">
          <h1 className="header__title">
            <span></span> Junk Removal in Tacoma
          </h1>

          <p className="header__subtitle">
            Sustainable solutions for a cleaner community. Our approach prioritizes donation and recycling, keeping more than 70 percent of collected items out of landfills. Every haul is tracked and reported so you know exactly where your items go.
          </p>

          <div className="header__cta-group">
            <a href="https://book.squareup.com/appointments/41vplmwf0luh01/location/LTHMTFD90TMRT/services" className="header__btn primary">
             Schedule your pickup
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M7.5 5L12.5 10L7.5 15"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>

            {/* Updated Schedule button */}
            <a
              href="/about"
              className="header__btn secondary"
           
              rel="noopener noreferrer"
            >
             About Us
            </a>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="header__indicators">
        {IMAGES.map((_, index) => (
          <button
            key={index}
            className={`header__indicator ${index === currentSlide ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </header>
  );
};

export default Header;
